(async () => {
  if (window.RebuyOriginalApplyDiscount) {
    return;
  }

  // Wait for Rebuy and Abra to be available
  while (!window.Rebuy || !window.Rebuy.SmartCart || !window.Rebuy.SmartCart.applyDiscount || !window.Abra) {
    await new Promise(resolve => setTimeout(resolve, 100));
  }

  // Hijack Rebuy discount apply
  window.RebuyOriginalApplyDiscount = window.Rebuy.SmartCart.applyDiscount;
  window.Rebuy.SmartCart.applyDiscount = function (...args) {
    var event = args[1];

    if (event && event.target && event.target.querySelector('#rebuy-cart__discount-input')) {
      var discountCode = event.target.querySelector('#rebuy-cart__discount-input').value;
      window.Abra.activate(discountCode);
    }

    window.RebuyOriginalApplyDiscount(...args);
  }
})();